import React from "react"
export function DownChevronFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm3.506 5.687L10 10.755 6.494 7.687l-.988 1.13 4 3.5.089.066a.75.75 0 00.81 0l.089-.067 4-3.5-.988-1.129z"
        fill="currentColor"
        id="prefix__down-chevron---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
